<template>
  <div id="app" :style="appStyle">
    <bar />
    <router-view />
  </div>
</template>
<script>
import Bar from '@/components/Bar'
import { getThemeAccountId, setThemeAccountId } from '@/libs/cookie-storage'
import { miniColors } from '@/utils/miniColors'

const VAR_KEYS = ['bg1', 'bg2', 'bg3', 'font-color1', 'font-color2', 'font-color3']

export default {
  components: { Bar },
  data() {
    return {
      appStyle: {}
    }
  },
  watch: {
    '$route.query': {
      handler() {
        this.applyAccountColors()
      },
      immediate: false
    }
  },
  // 须在子页面 mounted 之前写入 theme accountId cookie，故用 created，勿仅用 mounted（Vue2 子先于父 mounted）
  created() {
    this.applyAccountColors()
  },
  methods: {
    applyAccountColors() {
      const fromRoute = this.$route.query.accountId
      if (fromRoute) {
        setThemeAccountId(fromRoute)
      }
      const accountId = fromRoute || getThemeAccountId()
      if (!accountId) return

      const theme = miniColors.find(item => String(item.accountId) === String(accountId))
      if (!theme) {
        // 未在 miniColors 配置主题时仍保留 accountId cookie（供业务读取），仅不应用换肤
        this.appStyle = {}
        return
      }
      const style = {}
      VAR_KEYS.forEach(key => {
        const value = theme[key]
        if (value != null) style[`--${key}`] = value
      })
      this.appStyle = style

      // 路由里出现一次匹配后持久化，后续页面可不带 accountId
    }
  }
}
</script>
<style>
#app {
  --bg1: #F0F0F3;
  --bg2: #FFFFFF;
  --bg3: #E20013;
  --font-color1: #1D2129;
  --font-color2: #606266;
  --font-color3: #646566;
}
</style>
